"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameRecord = exports.colorLabSamopleStatusGR = exports.statusColorsLabSampleGR = exports.DefaultSpeciesIcons = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
var GameRecordGender;
(function (GameRecordGender) {
    GameRecordGender["MALE"] = "M";
    GameRecordGender["FEMALE"] = "F";
})(GameRecordGender || (GameRecordGender = {}));
exports.DefaultSpeciesIcons = [
    "DIWIMA_Icons_Wildarten_Dachs",
    "DIWIMA_Icons_Wildarten_Waschbaer",
    "icnDamwild",
    "icnFuchs",
    "icnMuffelwild",
    "icnRehwild",
    "icnRotwild",
    "icnSchwarzwild",
    "icnSikawild",
    "icnNutria",
    "icnCwd",
    "icnMuntjac"
];
exports.statusColorsLabSampleGR = [
    {
        type: "receivedResult",
        color: "white",
        sort: 3
    },
    {
        type: "pendingSubmission",
        color: "rgba(255,255,0,0.3)", //yellow
        sort: 2
    },
    {
        type: "pendingResults",
        color: "rgba(255,255,0,0.3)", //yellow
        sort: 2
    },
    {
        type: "certificatePending",
        color: "rgba(255,255,0,0.3)", //yellow
        sort: 2
    },
    {
        type: "skippedSubmission",
        color: "rgba(255, 0, 0, 0.6)", //red
        sort: 1
    },
    {
        type: "submissionFailed",
        color: "rgba(255, 0, 0, 0.6)", //red
        sort: 1
    },
    {
        type: "certificateFailed",
        color: "rgba(255, 0, 0, 0.6)", //red
        sort: 1
    },
    {
        type: "authenticationFailed",
        color: "rgba(255, 0, 0, 0.6)", //red
        sort: 1
    },
    {
        type: "sampleRejected",
        color: "rgba(255, 0, 0, 0.6)", //red
        sort: 1
    },
    {
        type: "certificateCreated",
        color: "white",
        sort: 3
    }
];
exports.colorLabSamopleStatusGR = {
    red: ["skippedSubmission", "submissionFailed", "certificateFailed", "authenticationFailed", "sampleRejected"],
    yellow: ["pendingSubmission", "pendingResult", "certificatePending"],
    white: ["receivedResult", "certificateCreated"]
};
class GameRecord {
    constructor(associatedContext) {
        this.className = "GameRecord";
        this.identifier = undefined;
        this.contextId = undefined;
        this.contextIds = undefined;
        this.contextIdRights = undefined;
        this.wildart = undefined;
        this.gender = undefined;
        this.age = undefined;
        this.tagid = undefined;
        this.officialGameTag = undefined;
        this.timeStamp = undefined;
        this.huntingDistrictId = undefined;
        this.huntingDistrictName = undefined;
        this.huntingDistrictAdministrativeName = undefined;
        this.ageInYears = undefined;
        this.placeOfKilling = undefined;
        this.placeOfKillingLatitude = undefined;
        this.placeOfKillingLongitude = undefined;
        this.gameCollectStationId = undefined;
        this.gameCollectStationName = undefined; // new 
        this.weights = undefined;
        this.erlegerId = undefined;
        this.erlegerAnzeigeName = undefined; // new
        this.hunterLocation = undefined;
        this.erlegeArt = undefined;
        this.erlegeArtTitle = undefined; // new
        this.eventId = undefined;
        this.eventName = undefined; // new
        this.shotQuality = undefined;
        this.shotQualityTitle = undefined; // new
        this.meatQuality = undefined;
        this.meatQualityTitle = undefined; // new
        this.comment = undefined;
        this.anteMortemInspectionComments = undefined;
        this.postMortemInspectionRequired = undefined;
        this.postMortemInspectionComment = undefined;
        this.unbekanntZuvorBeschossen = undefined;
        this.hasShootPrice = undefined;
        this.shootPrice = undefined;
        this.receiptNo = undefined;
        this.captureLocation = undefined;
        this.currentLocation = undefined;
        this.status = undefined;
        this.statusTitle = undefined; // new
        this.currentLocationID = undefined;
        this.currentLocationTitle = undefined; // new
        this.gameCount = undefined;
        this.imageCount = undefined;
        this.locationCoordinates = undefined;
        this.postingAccount = undefined;
        this.plannedUtilization = undefined;
        this.plannedUtilizationDisplay = undefined; // new
        this.plannedUtilizationDetails = undefined;
        this.updateTimestamp = undefined;
        this.creationDate = undefined;
        this.quality = undefined;
        this.hiTierState = undefined;
        this.hiTierResult = undefined;
        this.extra = undefined;
        this.gameOriginFormData = undefined;
        this.veterinarianOffice = undefined;
        this.huntingOffice = undefined;
        this.createdByUserId = undefined;
        this.createdByUserName = undefined;
        this.reportingImages = false;
        this.webTSNobject = undefined;
        this.laboratorySamples = undefined;
        this.context = undefined;
        this.context = associatedContext;
    }
    setFromAny(element) {
        const { identifier, contextId, contextIds, contextIdRights, wildart, gender, age, tagid, officialGameTag, timeStamp, updateTimestamp, creationDate, huntingDistrictId, huntingDistrictName, huntingDistrictAdministrativeName, ageInYears, placeOfKilling, placeOfKillingLatitude, placeOfKillingLongitude, 
        // species,
        gameCollectStationId, gameCollectStationName, weights, erlegerId, erlegerAnzeigeName, hunterLocation, erlegeArt, erlegeArtTitle, eventId, eventName, shotQuality, shotQualityTitle, meatQuality, meatQualityTitle, comment, anteMortemInspectionComments, postMortemInspectionRequired, postMortemInspectionComment, unbekanntZuvorBeschossen, hasShootPrice, shootPrice, receiptNo, captureLocation, currentLocation, status, statusTitle, currentLocationID, currentLocationTitle, gameCount, imageCount, locationCoordinates, postingAccount, plannedUtilization, plannedUtilizationDisplay, plannedUtilizationDetails, reportingIds, gameOriginFormData, quality, hiTierState, hiTierResult, extra, veterinarianOffice, huntingOffice, pictureURLlinks, reportingImages, webTSNobject, laboratorySamples, createdByUserId, createdByUserName } = element;
        // set title if no title is given
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.contextIds = contextIds ? contextIds : this.contextIds;
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights;
        this.wildart = wildart ? wildart : this.wildart;
        this.gender = gender ? gender : this.gender;
        this.age = age ? age : this.age;
        this.tagid = tagid ? tagid : this.tagid;
        this.officialGameTag = officialGameTag ? officialGameTag : this.officialGameTag;
        this.timeStamp = timeStamp ? (0, obejct_diff_1.isDate)(timeStamp) ? timeStamp : (0, obejct_diff_1.firestoreTimestampToDate)(timeStamp) : this.timeStamp;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId;
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName;
        this.huntingDistrictAdministrativeName = huntingDistrictAdministrativeName ? huntingDistrictAdministrativeName : this.huntingDistrictAdministrativeName;
        this.ageInYears = ageInYears ? ageInYears : this.ageInYears;
        this.placeOfKilling = placeOfKilling ? placeOfKilling : this.placeOfKilling;
        this.placeOfKillingLatitude = placeOfKillingLatitude ? placeOfKillingLatitude : this.placeOfKillingLatitude;
        this.placeOfKillingLongitude = placeOfKillingLongitude ? placeOfKillingLongitude : this.placeOfKillingLongitude;
        this.gameCollectStationId = gameCollectStationId ? gameCollectStationId : this.gameCollectStationId;
        this.gameCollectStationName = gameCollectStationName ? gameCollectStationName : this.gameCollectStationName;
        this.weights = weights ? weights : {};
        this.erlegerId = erlegerId ? erlegerId : this.erlegerId;
        this.hunterLocation = hunterLocation ? hunterLocation : this.hunterLocation;
        this.erlegeArt = erlegeArt ? erlegeArt : this.erlegeArt;
        this.eventId = eventId ? eventId : this.eventId;
        this.eventName = eventName ? eventName : this.eventName;
        this.plannedUtilization = plannedUtilization ? plannedUtilization : this.plannedUtilization;
        this.shotQuality = shotQuality ? shotQuality : this.shotQuality;
        this.meatQuality = meatQuality ? meatQuality : this.meatQuality;
        this.comment = comment ? comment : this.comment;
        this.anteMortemInspectionComments = anteMortemInspectionComments ? anteMortemInspectionComments : this.anteMortemInspectionComments;
        this.postMortemInspectionRequired = (postMortemInspectionRequired != undefined) ? postMortemInspectionRequired : this.postMortemInspectionRequired;
        this.postMortemInspectionComment = postMortemInspectionComment ? postMortemInspectionComment : this.postMortemInspectionComment;
        this.unbekanntZuvorBeschossen = (unbekanntZuvorBeschossen != undefined) ? unbekanntZuvorBeschossen : this.unbekanntZuvorBeschossen;
        this.hasShootPrice = (hasShootPrice != undefined) ? hasShootPrice : this.hasShootPrice;
        this.shootPrice = shootPrice ? shootPrice : this.shootPrice;
        this.receiptNo = receiptNo ? receiptNo : this.receiptNo;
        this.captureLocation = captureLocation ? captureLocation : this.captureLocation;
        this.currentLocation = currentLocation ? currentLocation : this.currentLocation;
        this.status = status ? status : this.status;
        this.currentLocationID = currentLocationID ? currentLocationID : this.currentLocationID;
        this.erlegerAnzeigeName = erlegerAnzeigeName ? erlegerAnzeigeName : this.erlegerAnzeigeName;
        this.gameCount = gameCount ? gameCount : this.gameCount;
        this.imageCount = imageCount ? imageCount : this.imageCount;
        this.locationCoordinates = locationCoordinates ? locationCoordinates : this.locationCoordinates;
        this.postingAccount = postingAccount ? postingAccount : this.postingAccount;
        this.plannedUtilizationDetails = plannedUtilizationDetails ? plannedUtilizationDetails : this.plannedUtilizationDetails;
        this.erlegeArtTitle = erlegeArtTitle ? erlegeArtTitle : this.erlegeArtTitle;
        this.shotQualityTitle = shotQualityTitle ? shotQualityTitle : this.shotQualityTitle;
        this.meatQualityTitle = meatQualityTitle ? meatQualityTitle : this.meatQualityTitle;
        this.statusTitle = statusTitle ? statusTitle : this.statusTitle;
        this.currentLocationTitle = currentLocationTitle ? currentLocationTitle : this.currentLocationTitle;
        this.plannedUtilizationDisplay = plannedUtilizationDisplay ? plannedUtilizationDisplay : this.plannedUtilizationDisplay;
        this.reportingIds = reportingIds ? reportingIds : this.reportingIds;
        this.gameOriginFormData = gameOriginFormData ? gameOriginFormData : this.gameOriginFormData;
        this.quality = quality ? quality : this.quality;
        this.hiTierState = hiTierState ? hiTierState : this.hiTierState;
        this.hiTierResult = hiTierResult ? hiTierResult : this.hiTierResult;
        this.extra = extra ? extra : this.extra;
        this.reportingImages = reportingImages ? reportingImages : this.reportingImages;
        this.veterinarianOffice = veterinarianOffice ? veterinarianOffice : this.veterinarianOffice;
        this.huntingOffice = huntingOffice ? huntingOffice : this.huntingOffice;
        this.pictureURLlinks = pictureURLlinks ? pictureURLlinks : this.pictureURLlinks;
        this.reportingImages = reportingImages ? reportingImages : this.reportingImages;
        this.webTSNobject = webTSNobject ? webTSNobject : this.webTSNobject;
        this.laboratorySamples = laboratorySamples ? laboratorySamples : this.laboratorySamples;
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId;
        this.createdByUserName = createdByUserName ? createdByUserName : this.createdByUserName;
        if (!erlegeArtTitle && !this.erlegeArtTitle && this.erlegeArt)
            this.erlegeArtTitle = this.getHuntingMethodTitle();
        if (!shotQualityTitle && !this.shotQualityTitle && this.shotQuality)
            this.shotQualityTitle = this.getShotQualitiesTitle();
        if (!meatQualityTitle && !this.meatQualityTitle && this.meatQuality)
            this.meatQualityTitle = this.getMeatQualitiesTitle();
        if (!statusTitle && !this.statusTitle && this.status)
            this.statusTitle = this.getCurrentStatusTitle();
        if (!currentLocationTitle && !this.currentLocationTitle && this.currentLocationID)
            this.currentLocationTitle = this.getCurrentLocationTitle();
        if (!plannedUtilizationDisplay && !this.plannedUtilizationDisplay && this.plannedUtilization)
            this.plannedUtilizationDisplay = this.getPlannedUtilizationTitle();
    }
    setTimeStampOrDate(time) {
        if (!time)
            return undefined;
        else if ((0, obejct_diff_1.isDate)(time))
            return time;
        else if ((0, obejct_diff_1.isFirebaseTimestamp)(time))
            return new Date(time.seconds * 1000);
        else
            return undefined;
    }
    setLocationCoordinates() {
    }
    searchFilter(filter) {
        const str = `${this.wildart}${this.huntingDistrictName}${this.tagid}${this.officialGameTag}${this.erlegerAnzeigeName}${this.age}`.toLowerCase();
        return str.includes(filter);
    }
    htmlBottomString() {
        var str = "";
        if (this.ageInYears)
            str += `${this.ageInYears}, `;
        if (this.gender)
            str += `${this.gender}, `;
        if (this.age)
            str += `${this.age}`;
        const strLength = str.length;
        if (str.substring(str.length - 2, str.length - 1) == ", ")
            str.slice(str.length - 2, str.length - 1);
        if (str[strLength - 1] == ",")
            str.slice(strLength - 1);
        return (str == "") ? undefined : str;
    }
    htmlErleger() {
        return (this.erlegerAnzeigeName) ? this.erlegerAnzeigeName : undefined;
    }
    getSpeciesTitle() {
        var _a, _b, _c, _d;
        if (!this.wildart)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_SPECIES;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return this.wildart ? this.wildart : undefined;
        const species = setting.values.find(el => el.identifier == this.wildart);
        if (!species)
            return this.wildart ? this.wildart : undefined;
        return ((_c = species.names) === null || _c === void 0 ? void 0 : _c.de) ? (_d = species.names) === null || _d === void 0 ? void 0 : _d.de : this.wildart;
    }
    getIconName() {
        var _a, _b;
        if (!this.wildart)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_SPECIES;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return undefined;
        const species = setting.values.find(el => el.identifier == this.wildart);
        if (!species)
            return undefined;
        return species.iconName;
    }
    getMeatQualitiesTitle() {
        var _a, _b;
        if (this.meatQualityTitle)
            return this.meatQualityTitle;
        if (!this.meatQuality)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_GR_MEAT_QUALITY;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return this.meatQuality ? this.meatQuality : undefined;
        const quality = setting.values.find(el => el.identifier == this.meatQuality);
        if (!quality)
            return this.meatQuality ? this.meatQuality : undefined;
        return quality.title ? quality.title : this.meatQuality ? this.meatQuality : undefined;
    }
    getShotQualitiesTitle() {
        var _a, _b;
        if (this.shotQualityTitle)
            return this.shotQualityTitle;
        if (!this.shotQuality)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_GR_SHOT_QUALITY;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return this.shotQuality ? this.shotQuality : undefined;
        const quality = setting.values.find(el => el.identifier == this.shotQuality);
        if (!quality)
            return this.shotQuality ? this.shotQuality : undefined;
        return quality.title ? quality.title : this.shotQuality ? this.shotQuality : undefined;
    }
    // future ... now age is always title... 
    getAgeTitle() {
        return this.age ? this.age : undefined;
        // if (!this.age && !this.gender) return undefined
        // if (!this.gender) return this.age ? this.age : undefined
        // const settingRef = NetworkConstants.SETTING_SPECIES
        // const setting = this.context?.settingsMap.get(settingRef)
        // if (!this.context || !setting) return this.age ? this.age : undefined
        // const species = setting.values.find(el => el.identifier == this.wildart)
        // if (!species) return this.age ? this.age : undefined
        // let genderClasses: any; 
        // if (this.gender == GameRecordGender.FEMALE) {
        //     genderClasses = species.ageClassesFemale
        // } else {
        //     genderClasses = species.ageClassesMale
        // }
        // if (!genderClasses) return this.age ? this.age : undefined
        // const {de} = genderClasses
        // return quality.title ? quality.title : this.shotQuality ? this.shotQuality : undefined
    }
    getCurrentLocationTitle() {
        var _a, _b;
        if (this.currentLocationTitle)
            return this.currentLocationTitle;
        if (!this.currentLocationID)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_GR_LOCATION;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return this.currentLocationID;
        const location = setting.values.find(el => el.identifier == this.currentLocationID);
        if (!location)
            return this.currentLocationID;
        return location.title ? location.title : this.currentLocationID;
    }
    getCurrentStatusTitle() {
        var _a, _b;
        if (!this.status)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_GR_STATUS;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return this.status;
        const status = setting.values.find(el => el.identifier == this.currentLocationID);
        if (!status)
            return this.status;
        return status.title ? status.title : this.currentLocationID;
    }
    getHuntingMethodTitle() {
        var _a, _b;
        if (this.erlegeArtTitle)
            return this.erlegeArtTitle;
        if (!this.erlegeArt)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_HUNTING_METHODS;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return this.erlegeArt;
        const set = setting.values.find(el => el.identifier == this.erlegeArt);
        if (!set)
            return this.erlegeArt;
        return set.title ? set.title : this.erlegeArt;
    }
    getPlannedUtilizationTitle() {
        var _a, _b;
        if (this.plannedUtilizationDisplay)
            return this.plannedUtilizationDisplay;
        if (!this.plannedUtilization)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_UTILIZATION_OPTION;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!this.context || !setting)
            return this.plannedUtilization;
        const set = setting.values.find(el => el.identifier == this.plannedUtilization);
        if (!set)
            return this.plannedUtilization;
        return set.title ? set.title : this.plannedUtilization;
    }
    getFeature(strUnkown) {
        var _a, _b;
        const location = this.locationCoordinates ? this.locationCoordinates
            : ((_a = this.placeOfKilling) === null || _a === void 0 ? void 0 : _a.location) ? (_b = this.placeOfKilling) === null || _b === void 0 ? void 0 : _b.location
                : null;
        if (!location)
            return undefined;
        let { identifier, erlegerAnzeigeName, timeStamp, } = this;
        let wildart = this.getSpeciesTitle();
        let locationTitle = this.getCurrentLocationTitle();
        let status = this.getCurrentStatusTitle();
        let erlegeArt = this.getHuntingMethodTitle();
        let icon = this.getIconName();
        if (!icon) {
            icon = 'pin';
        }
        return {
            type: "Feature",
            properties: {
                identifier,
                erlegerAnzeigeName,
                wildart: wildart ? wildart : strUnkown,
                // for icon display
                icon: icon,
                type: wildart ? wildart : strUnkown,
                status: status ? status : strUnkown,
                currentLocationID: locationTitle ? locationTitle : strUnkown,
                timeStamp,
                erlegeArt: erlegeArt ? erlegeArt : strUnkown,
            },
            geometry: {
                type: 'Point',
                coordinates: [location.longitude, location.latitude]
            }
        };
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        if (key == "context")
            return false;
        else
            return true;
    }
}
exports.GameRecord = GameRecord;
GameRecord.className = "GameRecord";
